import { FunctionComponent } from "react";
import { Link } from "react-router";

interface Props {
  userId?: string;
}

export const Footer: FunctionComponent<Props> = ({ userId }) => {
  return (
    <footer className="app-footer">
      <span>&#169; {new Date().getFullYear()} webtie.ch</span>
      <a href="https://www.webtie.ch/#contact" target="_blank" rel="noreferrer">
        Kontakt
      </a>
      <Link to="/datenschutz">Datenschutz</Link>
      <Link to="/agb">AGB</Link>
      {userId && (
        <Link to={`/user/${userId}/plus`} className="app-footer__plus">
          Spielgruppe Plus
        </Link>
      )}
      <span className="app-footer__address">Im Feld 13c, 5712 Beinwil am See</span>
    </footer>
  );
};
